(function() {
  'use strict';

  // Initialize all read more components on the page
  function initAllReadMore() {
    const readMoreContainers = document.querySelectorAll('[data-collection-description="true"]');
    
    readMoreContainers.forEach(function(container) {
      initReadMore(container);
    });
  }

  // Initialize a single read more component
  function initReadMore(readMoreContainer) {
    const content = readMoreContainer.querySelector('.collection-description-readmore__content');
    const toggle = readMoreContainer.querySelector('.collection-description-readmore__toggle');
    
    if (!content || !toggle) {
      return;
    }
    
    const toggleText = toggle.querySelector('.collection-description-readmore__toggle-text');
    if (!toggleText) {
      return;
    }
    
    // Get text values from data attributes or use defaults
    const readMoreText = readMoreContainer.getAttribute('data-read-more-text') || 'Read more';
    const readLessText = readMoreContainer.getAttribute('data-read-less-text') || 'Read less';
    
    // Ensure button is visible by default
    toggle.style.display = 'inline-block';
    
    // Check if content needs read more (if it's taller than 150px)
    function checkIfNeedsReadMore() {
      // Temporarily remove collapsed class to measure full height
      const wasCollapsed = content.classList.contains('collection-description-readmore__content--collapsed');
      content.style.maxHeight = 'none';
      const originalHeight = content.scrollHeight;
      
      if (wasCollapsed) {
        content.style.maxHeight = '';
        content.classList.add('collection-description-readmore__content--collapsed');
      }
      
      if (originalHeight <= 150) {
        toggle.style.display = 'none';
        content.classList.remove('collection-description-readmore__content--collapsed');
      } else {
        toggle.style.display = 'inline-block';
      }
    }
    
    // Run check after a short delay to ensure content is rendered
    setTimeout(checkIfNeedsReadMore, 100);
    
    // Also check when images load
    const images = content.querySelectorAll('img');
    if (images.length > 0) {
      images.forEach(function(img) {
        if (img.complete) {
          checkIfNeedsReadMore();
        } else {
          img.addEventListener('load', checkIfNeedsReadMore);
        }
      });
    }
    
    // Handle window resize
    let resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(checkIfNeedsReadMore, 250);
    });
    
    // Handle toggle click
    toggle.addEventListener('click', function() {
      const isExpanded = this.getAttribute('aria-expanded') === 'true';
      
      if (isExpanded) {
        content.classList.remove('collection-description-readmore__content--expanded');
        content.classList.add('collection-description-readmore__content--collapsed');
        this.setAttribute('aria-expanded', 'false');
        toggleText.textContent = readMoreText;
      } else {
        content.classList.remove('collection-description-readmore__content--collapsed');
        content.classList.add('collection-description-readmore__content--expanded');
        this.setAttribute('aria-expanded', 'true');
        toggleText.textContent = readLessText;
      }
    });
  }

  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllReadMore);
  } else {
    initAllReadMore();
  }
})();

